import React from "react";
import { Button, Typography } from "antd";

const { Title, Text } = Typography;

export default function PlaceHolderContent({
  title,
  description,
  imgSrc,
  imgAlt,
  buttonUrl,
}) {
  return (
    <div className="login-bg-image">
      <article className="login-content">
        <img className="login-content-image" src={imgSrc} alt={imgAlt} />
        <div className="login-content-text">
          <Title level={2}>{title}</Title>
          <Text className="login-content-description">{description}</Text>
        </div>
        {buttonUrl ? (
          <Button
            href={buttonUrl}
            size="large"
            type="ghost"
            className="login-content-button"
            target="_blank"
          >
            Lees meer
          </Button>
        ) : null}
      </article>
    </div>
  );
}
